// import functions from "./Functions"
import MD5 from "md5";

const Gender = ["Male", "Female", "Other"]
const checkFile = (files) => {
    let result = false
    if (files) {
        if (files.length > 0) {
            files.forEach(file => {
                if (file.size < (10 * 1024 * 1024)) {
                    result = true
                }
            });
        } else {
            if (files.size < (10 * 1024 * 1024)) {
                result = true
            }
        }
    }
    return result
}

// Helper & Partial Functions
const minLen = l => v => (v && v.length >= l) || `minimum. ${l} Character(s)`
const maxLen = l => v => (v && v.length <= l) || `maximum. ${l} Character(s)`
const required = msg => v => !!v || msg
const matchcode = code => v => (!!v && MD5(v) === code) || `Code must match the one sent via email or mobile`
const minage = (msg, maxdate) => v => (new Date(v) < new Date(maxdate)) || msg
const maxFileSize = (maxsize) => v => (checkFile(v) === true) || `File must be less than 10 MB`
const requiredArray = msg => v => (Array.isArray(v) && v.length > 1) || msg
const requiredSingleArray = msg => v => (Array.isArray(v) && v.length > 0) || msg

// Rules
export default {
    minAge: (msg, maxdate) => minage(msg, maxdate),
    requiredMsg: (msg) => required(msg),
    codeCheck: (code) => matchcode(code),
    requiredSelMult: requiredArray('2 Selections are required'),
    requiredSelSingle: requiredSingleArray('Atleast one Selection is required'),
    max12: maxLen(12),
    max1: maxLen(1),
    min6: minLen(6),
    fileSize: () => maxFileSize(),
    validEmail: v => /.+@.+\..+/.test(v) || 'E-mail must be valid',
    Gender: ["Male", "Female", "Non-Binary", "Different Identity", "Prefer Not to Say"],
}
